import { RequireAuth } from "./components.js";
import { HelmLayout } from "./layouts.js";
import { ActionTable } from "./table.js";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { ListBullets } from "@phosphor-icons/react";
import {
  EmptyState,
  EmptyStateIcon,
  EmptyStateTitle,
  EmptyStateDescription,
} from "@/components/ui/empty-state";

const ActionsPageContent = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Action Log</CardTitle>
        <CardDescription>
          Recent actions executed in this organization.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ActionTable
          emptyState={
            <EmptyState>
              <EmptyStateIcon>
                <ListBullets />
              </EmptyStateIcon>
              <EmptyStateTitle>No actions yet</EmptyStateTitle>
              <EmptyStateDescription>
                Actions will appear here as they are executed.
              </EmptyStateDescription>
            </EmptyState>
          }
        />
      </CardContent>
    </Card>
  );
};

export const ActionsPage = () => {
  return (
    <RequireAuth>
      <HelmLayout>
        <ActionsPageContent />
      </HelmLayout>
    </RequireAuth>
  );
};
